module.exports = __webpack_public_path__ + "img/geod_15.927c3180.jpg";